import {A, AnchorProps} from "@solidjs/router";
import {JSX, splitProps} from "solid-js";
import css from "./button.module.css";

type Variant = keyof typeof css;

interface ButtonProps extends JSX.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: Variant;
}

export function Button(props: ButtonProps) {
    const [local, rest] = splitProps(props, ["variant", "children", "class"]);
    const variantClass = local.variant ? css[local.variant] : "";

    return (
        <button class={`${css.button} ${variantClass} ${local.class || ""}`.trim()} {...rest}>
            {local.children}
        </button>
    );
}

interface LinkButtonProps extends AnchorProps {
    variant?: Variant;
}

export function LinkButton(props: LinkButtonProps) {
    const [local, rest] = splitProps(props, ["variant", "children", "class"]);
    const variantClass = local.variant ? css[local.variant] : "";

    return (
        <A class={`${css.button} ${variantClass} ${local.class || ""}`.trim()} {...rest}>
            {local.children}
        </A>
    );
}